import {simpleCurrency2} from 'app/format/currency'
import clsx from 'clsx'
import {FC} from 'react'

type Props = {
  title: any
  children?: any
  className?: string
  value: any | number
  isValueBolder?: boolean
  isBetween?: boolean
  isDiscount?: boolean
  isPrimaryActive?: boolean
  isTitleBolder?: boolean
  isValueSuccess?: boolean
  isValueDanger?: boolean
}

const SummaryItem: FC<Props> = ({
  title,
  children,
  value,
  isValueBolder,
  className,
  isBetween,
  isDiscount,
  isPrimaryActive,
  isTitleBolder,
  isValueSuccess,
  isValueDanger,
}) => {
  if (isBetween) {
    return (
      <div className='d-flex justify-content-between align-items-center'>
        <div
          className={clsx(
            isTitleBolder && 'fw-bolder',
            'fs-6 mb-3',
            isPrimaryActive && 'text-primary-active'
          )}
        >
          {title}
        </div>
        {children && <div className='col-6'>{children}</div>}
        <div className={clsx('text-end text-dark', isValueBolder && 'fw-bolder')}>
          {isDiscount && value > 0 && '-'} {simpleCurrency2(value)}
        </div>
      </div>
    )
  }

  return (
    <div className={clsx('row w-100 fs-6 fw-bold d-flex align-items-center', className)}>
      <div
        className={clsx(
          children ? 'col-4' : 'col-10',
          isTitleBolder && 'fw-bolder',
          'fs-6 mb-3',
          isPrimaryActive && 'text-primary-active'
        )}
      >
        {title}
      </div>
      {children && <div className='col-6'>{children}</div>}
      <div
        className={clsx(
          'col-2 text-end',
          isValueBolder && 'fw-bolder',
          isValueSuccess && 'text-success',
          isValueDanger && 'text-danger',
          !isValueBolder && !isValueSuccess && 'text-dark'
        )}
      >
        {isDiscount && parseFloat(value) > 0 && '-'} {simpleCurrency2(value)}
      </div>
    </div>
  )
}

export default SummaryItem
